import { render, staticRenderFns } from "./BindNew.vue?vue&type=template&id=aec68096&scoped=true&"
import script from "./BindNew.vue?vue&type=script&lang=js&"
export * from "./BindNew.vue?vue&type=script&lang=js&"
import style0 from "./BindNew.vue?vue&type=style&index=0&id=aec68096&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec68096",
  null
  
)

export default component.exports